// src/utils/auth.js
import Base64 from "crypto-js/enc-base64";
import CryptoJS from "crypto-js";
import sessionStorage from './SessionStorage.utils';

export const generateSignature = (timestamp) => {
  const accessKey = process.env.REACT_APP_API_ACC_KEY;
  if (typeof accessKey !== "string" || accessKey.length <= 0) throw new Error("Access key not set");

  const hash = CryptoJS.algo.SHA256.create().update(timestamp).update(accessKey).finalize();

  return Base64.stringify(hash);
};

export const _getAuthHeaders = (timestamp, isSecureRoute) => {
  const headers = {
    "x-awapp-apigw-timestamp": timestamp,
    "x-awapp-apigw-signature-v2": generateSignature(timestamp),
    "Content-Type": "application/json",
  };

  if (isSecureRoute) {
    headers.Authorization = `Bearer ${sessionStorage.getItem("token")}`;
  }

  return headers;
};

export const getAuthHeaders = () => {
  console.log('getAuthHeaders')
  const timestamp = Date.now().toString();

  const headers = {
    "Content-Type": "application/json",
    "x-awapp-apigw-timestamp": timestamp,
    "x-awapp-apigw-signature-v2": generateSignature(timestamp),
  };
  const adminSession = sessionStorage.getItemJsonParse("adminSession");
  console.log('adminSession', adminSession)
  if (!adminSession || !adminSession.accessToken) {
    console.log('토큰없음')
    // throw new Error("Customer session or access token not found");
  } else {
    headers.Authorization = `Bearer ${adminSession.accessToken}`;
  }

  // headers.Authorization = `Bearer ${sessionStorage.getItemJsonParse("adminSession").accessToken}`;
  //if (sessionStorage.getItem("adminSession").accessToken) headers.Authorization = `Bearer ${sessionStorage.getItem("adminSession").accessToken}`;

  // if (sessionStorage.getItem("accessToken")) headers.Authorization = `Bearer ${sessionStorage.getItem("accessToken")}`;
  // if (sessionStorage.getItem("adminAccessToken"))
  //   headers.Authorization = `Bearer ${sessionStorage.getItem("adminAccessToken")}`;

  return headers;
};
